import {api} from '@tubo/tubo-base'

api.libClient.companyScope = '/api/v1/lib/client/company/scope'

api.gzw = {
  queryOrg: '/api/v1/society/seal/site/query/org',

  // 通过印章识别码查询印章详情
  sealContentIdentity: '/api/v1/gzw/seal/content/identity/:identity',

  //
  sealOrgUscc: '/api/v1/gzw/seal/org/uscc/:uscc',

  // 获取章材列表
  queryOrderMaterial: '/api/v1/gzw/query/order/material',
}

api.gzwCusOrder = {
  // 拉取法定代表人手机号和经办人手机号相符的推送信息
  aic: '/api.cus/v1/gzw/cus/order/aic',

  // 根据工商订单选择线下办理并选择刻章企业
  aicOffline: '/api.cus/v1/gzw/cus/aic/offline',

  // 根据工商推送生成实物公章订单
  importAic: '/api.cus/v1/gzw/cus/order/import/aic',

  // 印章刻制订单-当前订单列表
  orderActive: '/api.cus/v1/gzw/cus/order/active',

  // 印章刻制订单-历史订单列表
  orderHistory: '/api.cus/v1/gzw/cus/order/history',

  // 印章刻制订单-新增/编辑/详情/删除
  order: '/api.cus/v1/gzw/cus/order/:id',

  // 印章订单-印章-列表/新增/编辑/删除
  orderSeal: '/api.cus/v1/gzw/cus/order/seal/:id',

  // 印章订单-支付宝PC-WEB唤起页面
  orderPayAlipayPc: '/api.cus/v1/gzw/cus/order/pay/alipay/pc/',

  //印章订单-支付宝MOBILE-WEB唤起页面
  payAlipayMobile: '/api.cus/v1/gzw/cus/order/pay/alipay/mobile/',

  // 印章订单-获取微信扫码图片
  orderPayWxScan: '/api.cus/v1/gzw/cus/order/pay/wx/scan/',

  // 印章订单-获取章材列表
  queryMaterial: '/api.cus/v1/gzw/cus/order/query/material',

  // 微信WEB唤起支付
  orderPayWxH5: '/api.cus/v1/gzw/cus/order/pay/wx/h5/',

  // 印章订单-微信JSAPI支付数据MAP返回
  orderPayWxJsapi: '/api.cus/v1/gzw/cus/order/pay/wx/jsapi/:id',
}

api.sealWebCus = {

  orderSubmitCompany: '/api.cus/v1/seal/web/cus/order/submit_company/:id',
}


api.webCusFree = {
  // 免费刻章买单方列表
  payer: '/api.cus/v1/web/cus/free/payer',

  // 免费刻章网点列表
  locale: '/api.cus/v1/web/cus/free/locale',

  // 免费刻章套餐列表
  plan: '/api.cus/v1/web/cus/free/plan',

  // 免费刻章预约-申请和列表
  reservation: '/api.cus/v1/web/cus/free/reservation',

  // 免费刻章预约-取消
  opReservationCancel: '/api.cus/v1/web/cus/free/op/reservation/cancel/:id',
}


export default api
